// Set the shared logger min level from the Vite runtime that owns it.

import {
  configureLogger,
  resolveLogLevel,
} from '@airhead-games/shared/utilities';

configureLogger({
  minLevel: resolveLogLevel({ isProduction: import.meta.env.PROD }),
});
